import {
  List,
  ListFolder,
  ListFoldersGraphQLQueryResponse,
  ListSubfolder,
  maybeSplitFolderContents,
} from 'modules/domains';
import { fetchListFoldersQuery } from 'api/queries';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GRAPHQL_TYPENAMES, GraphQLResponsePaginationInfo } from 'modules/graphql';
import { useListsVariables } from './useListsVariables';

export function useListFolders(
  listFolderIdVariables: Partial<{ rootFolderId: number; folderId: number }>,
) {
  const variables = useListsVariables(listFolderIdVariables);
  const {
    data: folderQueryData,
    isLoading,
    error: isError,
    refetch,
  } = useGraphql<ListFoldersGraphQLQueryResponse>(fetchListFoldersQuery, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    variables,
  });
  const { info = {}, content, ...folderData } = folderQueryData?.listFolder ?? {};

  const [listFolders, lists] = maybeSplitFolderContents<ListSubfolder, List>(
    GRAPHQL_TYPENAMES.LIST,
    content,
  );

  return {
    listFolders: listFolders as ListSubfolder[],
    lists,
    folderData: folderData as ListFolder,
    paginationInfo: info as GraphQLResponsePaginationInfo,
    isLoading,
    isError,
    refetch,
  };
}
